/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import moment from 'moment'
import _, { filter } from 'lodash'
// eslint-disable-next-line
import {
  Solicitacao, Convenio, Plano, Laudo, ErrorMessage, Cid,
  ModalSolicitacaoCirurgia, Procedimento, OPME, Fornecedor, NovoFornecedor, Equipamento,
  IRequestMessage, ReservaHemocomponente, Hemocomponente, AgendamentoMedico, Medico,
  Hospital, OpmePostResponse, TemplateHospital, MedicoSolicitante, Snackbar, TipoDocumentoUpload, LocalAtendimento, ProtocoloOPME, ItemAutorizado, MotivoCancelamento, AlteracaoDataAgendamento, AlteracaoDataMensagem, SolicitacaoQueryString, SecretariaDoMedicoSolicitante } from '@/types/_'
import { dateToTimestamp, instrumentador, formatDateGetApi, assinarEnviar, splitUppercase, formatPhoneMask } from '@/utils/common'
import Apis from '@/Apis/_'
import StatusSituacao from '@/components/SolicitacaoCirurgia/store/StatusSituacao'
import EventBus from '@/plugins/EventBus'
import { Carater, Situacao } from '@/types/interfaces/Solicitacao'

@Module({ namespaced: true, name: 'SolicitacaoStore' })
export default class SolicitacaoStore extends VuexModule {
  errorMessageDefault: ErrorMessage = {
    errorTipoAnestesia: '',
    errorTipoAnestesiaPaciente: '',
    errorOutrasAlergias: '',
    errorviasAereasDificilAcesso: '',
    success: false,
    total: 0,
    errorAlergiaLatex: '',
    errorCarater: '',
    errorCarteirinha: '',
    errorCelular: '',
    errorCids: '',
    errorConcentradoHemaciasQnt: '',
    errorConcentradoPlaquetasQnt: '',
    errorConvenio: '',
    errorCrioprecipitadoQnt: '',
    errorDataNascimento: '',
    errorDataPrevista1: '',
    errorDataPrevista2: '',
    errorDataPrevista3: '',
    errorDiagnosticoJustificativa: '',
    errorDiarias: '',
    errorEmail: '',
    errorEquipamento: '',
    errorEspecificacaoExameIntraOperatorio: '',
    errorEspecificarAlergia: '',
    errorEspecificarPrecaucoes: '',
    errorHonorarioMedico: '',
    errorLateralidade: '',
    errorOPME: '',
    errorOpmeFornecedor1: '',
    errorOpmeQuantidade: '',
    errorPaciente: '',
    errorPlano: '',
    errorPlasmaFrescoCongeladoQnt: '',
    errorPrecaucoes: '',
    errorProcedimento: '',
    errorReservaHemocomponentes: '',
    errorReservaUti: '',
    errorTelefone: '',
    errorTempoCirurgia: '',
    errorTipoProcedimento: '',
    errorMedicamentosEspeciaisDescricao: '',
    errorPrevisaoUsoQuimioterapicoDescricao: '',
    errorAnestesistaHospital: '',
    errorMedicamentosEspeciais: '',
    errorQuimioterapico: '',
    errorRecemNascido: '',
    errorSexo: '',
    errorEquipeDoHospital: '',
  }

  public medicoSolicitante: MedicoSolicitante = {
    cpf: '',
    conselhoTipo: 'CRM',
    conselhoNumero: '',
    conselhoUf: '',
    email: '',
    especialidade: '',
    hospitais: [],
    id: '',
    medicoTemUsuario: false,
    nome: '',
    recebeEmailNotificacao: false,
    telefone: '',
    urlAssinatura: '',
  }

  public secretariaDoMedicoSolicitante: SecretariaDoMedicoSolicitante = {
    nome: '',
    telefone: '',
    email: '',
  }

  private solicitacaoDefault: Solicitacao = {
    id: '',
    observacaoReservaSala: null,
    nomePaciente: '',
    hospitalId: '',
    dataNascimento: null,
    dataNascimentoTemp: '',
    telefone: '',
    celular: '',
    email: '',
    convenio: null,
    plano: null,
    carteirinha: '',
    diagnosticoJustificativa: '',
    resultadosDeExames: null,
    tempoCirurgia: null,
    opcaoDataPrevisto1: null,
    opcaoDataPrevisto2: null,
    opcaoDataPrevisto3: null,
    opcaoDataPrevisto1Temp: '',
    opcaoDataPrevisto2Temp: '',
    opcaoDataPrevisto3Temp: '',
    instrucaoData: null,
    dataAgendamentoVirtual: false,
    dataAgendamento: '',
    instrucaoDataPrevista: '',
    especificarPrecaucoes: '',
    alergiaLatexTemp: '',
    alergiaLatex: null,
    alergiaContraste: null,
    testeCovid: null,
    marcapasso: null,
    reoperacao: null,
    especificarOutrasAlergias: null,
    carater: null,
    caraterTemp: null,
    files: [],
    laudos: [],
    resumos: [],
    cids: null,
    diaria: null,
    equipamentos: null,
    caixasCirurgicas: [],
    especificacaoExameIntraOperatorio: '',
    examesIntraOperatorios: {
      anatomiaPatologica: false,
      anatomiaPatologicaHospitalOuParticular: null,
      anatomiaPatologicaParticularLocal: null,
      biobanco: false,
      biopsia: false,
      biopsiaHospitalOuParticular: null,
      biopsiaParticularLocal: null,
      broncoscopiaFlexivel: false,
      catho: false,
      cellSaver: false,
      colangiografia: false,
      colangiopancreatografiaRetrograda: false,
      colonoscopia: false,
      congelacaoIPC: false,
      congelacaoMultipat: false,
      congelacaoPathos: false,
      congelacaoFerdinando: false,
      congelacaoSalomao: false,
      congelacaoLoccus: false,
      congelacaoFleury: false,
      congelacaoEinstein: false,
      congelacaoBML: false,
      congelacaoCIPAC: false,
      congelacaoPathology: false,
      dimen: false,
      ecocardiograma: false,
      ecointraoperatório: false,
      ecotransesofagico: false,
      endoscopia: false,
      escleraUnicamp: false,
      examesLaboratoriais: false,
      fivmed: false,
      insite: false,
      mamografia: false,
      medicinaNuclear: false,
      monitorizacaoNeurofisiologica: false,
      nervoNIM: false,
      neuronavegacao: false,
      outros: false,
      outrosEspecificar: null,
      potencialEvocado: false,
      pth: false,
      radioterapia: false,
      ressonancia: false,
      rxScopia: false,
      semExameIntraoperatorio: false,
      tipagemSanguinea: false,
      tomografia: false,
      tomografiaParaEstereotaxia: false,
      transporte: false,
      udo: false,
      ultrassonografiaDeImagem: false,
      ultrassonografiaIntraoperatoria: false,
      ultrassonografiaIntraoperatoriaEquipeDoHospital: null,
      ultrassonografiaLaparoscopio: false,
      ultrassonografiaRadiologia: false,
      ultrassonografiaRadiologiaAcompanhamento: false,
    },
    honorarioMedico: null,
    honorarioMedicoDocumento: null,
    honorarioMedicoTemp: null,
    idade: null,
    lateralidade: null,
    medicoSolicitanteId: '',
    opmes: [],
    orientacaoPreparoPaciente: '',
    precaucoesTemp: null,
    precaucoes: null,
    procedimento: {} as Procedimento,
    procedimentosAssociados: [],
    reservaHemocomponentes: {
      concentradoHemacias: {
        quantidade: null,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: null,
        value: false,
      },
      crioprecipitado: {
        quantidade: null,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: null,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: null,
        value: false,
      },
      semReserva: {
        quantidade: null,
        value: false,
      },
    },
    reservaUTI: {
      display: '',
      key: '',
    },
    reservaUtiTemp: null,
    anestesiaDoHospital: null,
    anestesiaDoHospitalTemp: '',
    honorarioAnestesista: null,
    honorarioAnestesistaDocumento: null,
    tipoProcedimento: null,
    tipoInternacao: null,
    lateralidadeTemp: null,
    tipoProcedimentoTemp: null,
    temMedicamentosEspeciais: null,
    temMedicacaoContinua: null,
    medicamentosEspeciais: '',
    medicacaoContinua: '',
    medEspeciaisTemp: '',
    temPrevisaoUsoQuimioterapico: null,
    usoQuimioTemp: '',
    previsaoUsoQuimioterapico: null,
    recemNascido: null,
    recemNascidoTemp: null,
    sexo: '',
    statusSituacao: 'Incompleta',
    codigoPrestador: '',
    medicoSolicitante: this.medicoSolicitante,
    secretariaDoMedicoSolicitante: this.secretariaDoMedicoSolicitante,
    anestesistaCrm: '',
    nomeAnestesista: '',
    anestesista: null,
    numeroAgendamento: '',
    protocoloOPME: '',
    protocoloOperadora: '',
    autorizacaoValidade: '',
    dataAutorizacaoNaOperadora: '',
    autorizadoStatus: null,
    observacao: '',
    autorizacaoObservacao: '',
    situacao: {
      display: '',
      key: '',
    },
    acoes: {
      editar: false,
      podeResolverPendencia: false,
      aceitarAutorizacaoParcial: false,
      criarContestacao: false,
      responderContestacao: false,
      solicitarCancelamento: false,
      visualizarContestacao: false,
      visualizarItensAutorizados: false,
      agendamentoConfirmaCancelamento: false,
      agendamentoFazCancelamento: false,
      alterarData: false,
      analizarResposta: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
      autorizacaoFazAnalisePreCotacao: false,
      autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
      confirmarData: false,
      contatar: false,
      agendamentoRealizaTriagem: false,
      agendamentoAtualizaTriagem: false,
      visualizar: false,
      visualizarPendencia: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
      autorizacaoFazAnalisePosCotacao: false,
      autorizacaoResolvePendenciaRoboAutorizacao: false,
      autorizacaoFazRetornoParaCotacao: false,
      autorizacaoAutorizaNegociacaoParticular: false,
      agendamentoFazReservaDeSalaParticular: false,
      agendamentoInformaReservaEmSolicitacaoParticular: false,
    },
    canceladoMotivo: {
      display: '',
      key: '',
    },
    hospitalRealizaCotacao: null,
    cotacaoOperadorasExtraGrupo: {
      faturamentoDiretoComOperadora: false,
      notaFiscal: false,
      observacao: 'Outros',
      valor: null,
      cotacaoComUrgencia: false,
      dataReferenciaParaOperadora: '',
    },
    dataVerificacaoElegibilidade: '',
    elegivel: null,
    erroVerificacaoElegibilidade: null,
    observacaoPreAnestesia: null,
    tipoAnestesiaPaciente: null,
    outrasAlergias: null,
    tipoAnestesia: null,
    statusAvaliacaoPreAnestesia: {
      display: '',
      key: '',
    },
    pacienteAptoParaAnestesia: null,
    medicoAnestesistaPreAvaliacaoNome: '',
    preAnestesico: null,
    tipoAnestesiaTemp: null,
    viasAereasDificilAcesso: null,
    origem: null,
    outrosTipoAnestesia: null,
    pacienteUsaMarcaPasso: null,
    auditada: false,
    salaCirurgicaNome: '',
    auditadaObservacao: '',
    enviadaPor: {
      display: '',
      key: '',
    },
    opmeFornecedores: [],
    statusAguardandoOperadora: '',
    negociacaoParticularStatus: null,
    numeroOrcamento: null,
    etapa: {
      display: '',
      key: '',
    },
    localAtendimentoId: null,
    localAtendimentoNome: null,
    grupoOpmeDaSolicitacao: [],
    cpf: '',
    paciente: {
      carteirinha: '',
      celular: '',
      convenioId: '',
      convenioNome: '',
      cpf: '',
      rgh: '',
      dataNascimento: '',
      dataVerificacaoElegibilidade: '',
      elegivel: '',
      email: '',
      id: '',
      idade: '',
      nome: '',
      planoId: '',
      planoNome: '',
      categoriaId: '',
      categoriaNome: '',
      tipoAcomodacao: '',
      recemNascido: '',
      sexo: '',
      telefone: '',
      peso: '',
      altura: '',
    },
    historicoFamiliarHipertemiaMaligna: null,
    classificacaoAsa: null,
    observacaoComplementares: null,
    hospitalTemStepNaAutorizacaoParaAtualizarQuantidadeAutorizada: false,
    temInternacaoDeVespera: '',
    internacaoDeVespera: '',
    temReservaHemocomponentesSimples: null,
    pesoDoPaciente: null,
    tempoDeDoenca: null,
    farmacia: null,
    motivoCancelamentoDescricao: '',
    procedimentosInternacao: [],
    hospitalInsereProcedimentosDeInternacao: false,
    autorizacaoDeveInformarProtocoloDaOperadora: false,
    convenioExigeCodificacaoOpme: false,
    configuracaoOpme: {
      codificacaoDeOpmeEhObrigatorio: false,
      fazCodificacaoDeOpme: false,
      precificaValorUnitario: false,
      precificacaoValorUnitarioEhObrigatorio: false,
    },
    registraProtocoloDeRecuperacaoPrecoce: null,
    classificacaoCirurgia: null,
    numeroDoAtendimentoAoPacienteNoHospital: '',
    justificativaTecnica: '',
    apa: {
      notificacaoEnviada: false,
      preferenciaApa: false,
    },
    dadosGestacionais: {
      idadeGestacional: null,
      gemelar: null,
    },
  }

  public modalSolicitacaoCirurgia: ModalSolicitacaoCirurgia = {
    showCid: false,
    showProcedimentoPrincipal: false,
    showProcedimentoAssociado: false,
    showAssociadoQuantidade: false,
    showQuantidade: false,
    showOpme: false,
    showOpmeFornecedor: false,
    showProtocoloFornecedor: false,
    showEquipamento: false,
    showTecnicaRobotica: false,
    showHospitalOpcoes: false,
    showItensAutorizados: false,
    showItensAutorizadosClinica: false,
    showMotivoCancelamento: false,
    showSair: false,
    showGerenciar: false,
    showAlteracaoDataSolicitada: false,
    showAlteracaoDataSolicitadaClinica: false,
    showModalPendenciaProtocolo: false,
  }

  public procedimentoDefault: Procedimento = {
    procedimentoPrincipal: false,
    codigo: '',
    descricao: '',
    historicoMedico: false,
    id: '',
    procedimentoId: '',
    porte: '',
    quantidade: 1,
    lateralidade: '',
    temLateralidade: false,
    quantidadeAutorizada: 0,
    particular: false,
  }

  private protocoloOPMEDefault: ProtocoloOPME = {
    agrupamento: '',
    opmes: [],
    protocolo: false,
    position: 0,
    protocoloId: '',
  }

  private novoFornecedorDefault: NovoFornecedor = {
    nomeFornecedor: '',
    nomeFabricante: '',
    medicoId: '',
    hospitalId: '',
    contato: '',
  }

  public novoFornecedor: NovoFornecedor = { ...this.novoFornecedorDefault }

  public reservaHemocomponente: ReservaHemocomponente = {
    concentradoHemacias: {
      quantidade: 0,
      value: false,
    },
    concentradoPlaquetas: {
      quantidade: 0,
      value: false,
    },
    crioprecipitado: {
      quantidade: 0,
      value: false,
    },
    plasmaFrescoCongelado: {
      quantidade: 0,
      value: false,
    },
    tipagemSanguinea: {
      value: false,
    },
    tipagemSanguineaABORHPAI: {
      quantidade: 0,
      value: false,
    },
    semReserva: {
      quantidade: 0,
      value: false,
    },
  }

  public requestMessage: IRequestMessage = {
    avancar: {
      text: 'Carregando...',
    },
    search: 'Busando...',
    continuarDepois: {
      text: 'Enviando...',
    },
    init: {
      text: 'Carregando...',
    },
    status: true,
    deleteMessage: 'Deletando...',
    post: 'Enviando...',
    update: 'Atualizando...',
    messageFinish: 'Solicitação enviada com sucesso!',
    errorApi: 'Houve um erro no envio dos dados.',
    errorUpload: '',
  }

  public snackbar: Snackbar = {
    disabled: false,
    disabledBtn: false,
    message: '',
    show: false,
    timeout: 3000,
    color: '',
  }

  public hemocomponente: Hemocomponente = {
    quantidade: 0,
    tipo: '',
    solicitacaoId: '',
  }

  public templateHospital: TemplateHospital = {
    hospital: '',
  }

  public hospital: Hospital = {
    id: '',
    nome: '',
    urlAssinatura: '',
  }

  public itemAutorizadoDefault: ItemAutorizado = {
    status: {
      key: '',
      display: '',
    },
    anexos: [],
    justificativa: '',
  }

  public motivoCancelamentoDefault: MotivoCancelamento = {
    status: {
      key: '',
      display: '',
    },
    canceladoMotivo: {
      key: '',
      display: '',
    },
    anexos: [],
    justificativa: '',
  }

  private alteracaoDataAgendamentoDefault: AlteracaoDataAgendamento = {
    dataConfirmada: '',
    opcao1: '',
    opcao2: null,
    opcao3: null,
    solicitacaoId: '',
  }

  public templateFormulario: any = {}

  public template: any = {
    lateralidade: false,
  }

  public alteracaoDataAgendamento: AlteracaoDataAgendamento = { ...this.alteracaoDataAgendamentoDefault }

  private alteracaoDataAgendamentoMensagensDefault: AlteracaoDataMensagem[] = []
  public alteracaoDataAgendamentoMensagens: AlteracaoDataMensagem[] = { ...this.alteracaoDataAgendamentoMensagensDefault }

  public solicitacao = { ...this.solicitacaoDefault }
  public itemAutorizado = { ...this.itemAutorizadoDefault }
  public motivoCancelamento = { ...this.motivoCancelamentoDefault }
  public errorMessage = { ...this.errorMessageDefault }
  public procedimentoQuantidade = { ...this.procedimentoDefault }
  public protocoloOPMESelected: ProtocoloOPME = { ...this.protocoloOPMEDefault }
  public convenios: Convenio[] = []
  public planos: Plano[] = []
  public laudos: Laudo[] = []
  public orcamentoAnexo: Laudo[] = []
  public cids: Cid[] = []
  public cidsApi: Cid[] = []
  public procedimentosApi: Procedimento[] = []
  public fornecedores: Fornecedor[] = []
  public equipamentos: Equipamento[] = []
  public equipamentosSugeridos: Equipamento[] = []
  public equipamentosApi: Equipamento[] = []
  public agendamentosMedico: AgendamentoMedico[] = []
  public agendamentosMedicoTotal: number = 0
  public agendamentosSituacaoFiltros: Situacao[] = []
  public agendamentosSituacaoDataFiltros: Situacao[] = []
  public agendamentosHospitalFiltros: Hospital[] = []
  public currentUserHospitals: Hospital[] = []
  public medicos: Medico[] = []
  public hospitais: Hospital[] = []
  public isInstrumentador: boolean = false
  public isEnviarSolicitacao: boolean = false
  public statusSituacao = StatusSituacao.StatusSituacao
  public showForm: boolean = true

  public protocoloOPMEsApi: ProtocoloOPME[] = []
  public protocoloOPMEs: ProtocoloOPME[] = []
  public enableModalProtocoloFornecedor: boolean = true

  private locaisAtendimentoDefault: LocalAtendimento[] = []
  private localAtendimentoDefault: LocalAtendimento = {
    id: '',
    ambulatorio: null,
    ativo: null,
    nome: '',
  }

  public locaisAtendimento: LocalAtendimento[] = [...this.locaisAtendimentoDefault]
  public localAtendimento: LocalAtendimento = { ...this.localAtendimentoDefault }
  public localAtendimentoId: string | null = ''
  private filterCirurgiasDefault: string = 'dataStatusAlterado'
  public filterCirurgias: string = this.filterCirurgiasDefault

  @Mutation
  setTemplateFormulario(templateFormulario: any) {
    this.templateFormulario = templateFormulario
  }

  @Mutation
  clearTemplateFormulario() {
    this.templateFormulario = {}
  }

  @Mutation
  setTemplateLateralidade(value: boolean) {
    this.template.lateralidade = value
  }

  @Mutation
  setFilterCirurgias(value: string) {
    this.filterCirurgias = value
  }

  @Mutation
  clearFilterCirurgias() {
    this.filterCirurgias = this.filterCirurgiasDefault
  }

  @Mutation
  setSurgeryProtocolData(protocolData) {
    this.solicitacao.protocoloDeCirurgia = protocolData
  }

  @Action
  async getAllLocaisAtendimento(medicoId: string, hospitalId: string) {
    const req = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllLocalAtendimentoByMedico(medicoId, hospitalId)
    if (req.success) {
      this.context.commit('setLocaisAtendimento', req.data)
    }
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action
  async post() {
    this.solicitacao.dataNascimento = moment(this.solicitacao.dataNascimentoTemp).format('YYYY-MM-DD')
    this.solicitacao.origem = 'ClinicaMedico' // AmbulatorioHospital

    if (this.solicitacao.recemNascidoTemp) {
      this.solicitacao.recemNascido = this.solicitacao.recemNascidoTemp === '1'
    }

    if (this.solicitacao.caraterTemp) {
      this.solicitacao.carater = parseFloat(this.solicitacao.caraterTemp || '')
    }

    // @ts-ignore
    this.solicitacao.reservaUTI = parseFloat(this.solicitacao.reservaUtiTemp || '')

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.post(this.solicitacao.medicoSolicitanteId, this.solicitacao)

    if (request.success) {
      this.context.commit('setSolicitacaoId', request.data)
    }
    return request
  }

  @Action
  async finalizar() {
    const solicitacaoId = this.solicitacao.id
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.finalizar(solicitacaoId)
    return request.success
  }

  @Action
  async finalizarDisponivelParaEnvio(solicitacaoId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.finalizar(solicitacaoId)
    return request
  }

  @Action
  async getAgendamentoCirurgiaById(solicitacaoId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAgendamentoCirurgiaById(solicitacaoId)
    return request.success
  }

  @Action
  async put() {
    this.solicitacao.dataNascimento = moment(this.solicitacao.dataNascimentoTemp).format('YYYY-MM-DD')
    this.solicitacao.opcaoDataPrevisto1 = dateToTimestamp(this.solicitacao.opcaoDataPrevisto1Temp)
    this.solicitacao.opcaoDataPrevisto2 = dateToTimestamp(this.solicitacao.opcaoDataPrevisto2Temp)
    this.solicitacao.opcaoDataPrevisto3 = dateToTimestamp(this.solicitacao.opcaoDataPrevisto3Temp)
    this.solicitacao.origem = 'ClinicaMedico'

    if (this.solicitacao.procedimento && this.solicitacao.procedimento.id) {
      const procedimento = this.solicitacao.procedimento as any
      procedimento.lateralidade = procedimento.lateralidade && procedimento.lateralidade.key ? procedimento.lateralidade.key : procedimento.lateralidade
      if ([undefined, null].includes(procedimento.lateralidade)) procedimento.lateralidade = 'NaoAplica'
      procedimento.procedimentoId = procedimento.id

      this.solicitacao.procedimento = procedimento
    }


    if (this.solicitacao.procedimentosAssociados) {
      // eslint-disable-next-line no-return-assign
      this.solicitacao.procedimentosAssociados = this.solicitacao.procedimentosAssociados.map((elem: any) => {
        let lateralidade = elem.lateralidade && elem.lateralidade.key ? elem.lateralidade.key : elem.lateralidade
        if ([undefined, null].includes(lateralidade)) lateralidade = 'NaoAplica'
        return {
          ...elem,
          procedimentoId: elem.id,
          lateralidade,
        }
      })
    }

    if (this.solicitacao.caraterTemp) {
      this.solicitacao.carater = parseFloat(this.solicitacao.caraterTemp || '')
    }

    if (this.solicitacao.reservaUtiTemp) {
      // @ts-ignore
      this.solicitacao.reservaUTI = parseFloat(this.solicitacao.reservaUtiTemp || '')
    }

    if (this.solicitacao.tipoProcedimentoTemp) {
      this.solicitacao.tipoProcedimento = parseFloat(this
        .solicitacao.tipoProcedimentoTemp || '')
    }

    if (this.solicitacao.lateralidadeTemp) {
      this.solicitacao.lateralidade = parseFloat(this
        .solicitacao.lateralidadeTemp || '')
    }

    if (this.solicitacao.honorarioMedicoTemp) {
      this.solicitacao.honorarioMedico = parseFloat(this.solicitacao.honorarioMedicoTemp || '')
    }

    if (this.solicitacao.alergiaLatexTemp && (this.solicitacao.alergiaLatexTemp === '1' || this.solicitacao.alergiaLatexTemp === '2')) {
      this.solicitacao.alergiaLatex = parseFloat(this.solicitacao.alergiaLatexTemp || '2')
    }

    if (this.solicitacao.precaucoesTemp) {
      this.solicitacao.precaucoes = this.solicitacao.precaucoesTemp === '1' ? { key: 'Sim', display: 'Sim' } : { key: 'Nao', display: 'Não' }
      // this.solicitacao.precaucoes = this.solicitacao.precaucoesTemp === '1' ? 'Sim' : 'Nao'
    }

    if (this.solicitacao.recemNascidoTemp) {
      this.solicitacao.recemNascido = this.solicitacao.recemNascidoTemp === '1'
    }

    if (this.solicitacao.anestesiaDoHospitalTemp) {
      this.solicitacao.anestesiaDoHospital = this.solicitacao.anestesiaDoHospitalTemp === '1'
    }

    switch (this.solicitacao.medEspeciaisTemp) {
      case undefined:
        delete this.solicitacao.temMedicamentosEspeciais
        break
      case null:
        delete this.solicitacao.temMedicamentosEspeciais
        break
      case '1':
        this.solicitacao.temMedicamentosEspeciais = true
        break
      case '2':
        this.solicitacao.temMedicamentosEspeciais = false
        break
      default:
        delete this.solicitacao.temMedicamentosEspeciais
    }

    switch (this.solicitacao.usoQuimioTemp) {
      case undefined:
        delete this.solicitacao.temPrevisaoUsoQuimioterapico
        break
      case null:
        delete this.solicitacao.temPrevisaoUsoQuimioterapico
        break
      case '1':
        this.solicitacao.temPrevisaoUsoQuimioterapico = true
        break
      case '2':
        this.solicitacao.temPrevisaoUsoQuimioterapico = false
        break
      default:
        delete this.solicitacao.temPrevisaoUsoQuimioterapico
    }

    const request = await this.updateSurgerySolicitation({ id: this.solicitacao.id, payload: this.solicitacao })
    return request
  }

  @Action
  async updateSurgerySolicitation({ id, payload }) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.put(id, payload)
    return request
  }


  @Action({ commit: 'setSolicitacao' })
  async get(solicitacaoId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.get(solicitacaoId)

    if (request.success) {
      const solicitacaoCast = await request.data

      const loc = window.location.pathname.includes('/agendamento-cirurgia/editar')
      const status = request.data.statusSituacao === 'Incompleta'

      this.context.commit('setShowForm', status || loc)

      solicitacaoCast.dataNascimentoTemp = moment(solicitacaoCast.dataNascimento).format('YYYY-MM-DD')
      solicitacaoCast.hospitalId = _.toUpper(solicitacaoCast.hospitalId)

      if (solicitacaoCast.opcaoDataPrevisto1) {
        solicitacaoCast.opcaoDataPrevisto1Temp = formatDateGetApi(
          solicitacaoCast.opcaoDataPrevisto1,
        )
      }

      if (solicitacaoCast.opcaoDataPrevisto2) {
        solicitacaoCast.opcaoDataPrevisto2Temp = formatDateGetApi(
          solicitacaoCast.opcaoDataPrevisto2,
        )
      }

      if (solicitacaoCast.opcaoDataPrevisto3) {
        solicitacaoCast.opcaoDataPrevisto3Temp = formatDateGetApi(
          solicitacaoCast.opcaoDataPrevisto3,
        )
      }

      if (solicitacaoCast.recemNascido !== undefined) {
        solicitacaoCast.recemNascidoTemp = solicitacaoCast.recemNascido ? '1' : '2'
      }

      if (solicitacaoCast.anestesiaDoHospital !== undefined) {
        solicitacaoCast.anestesiaDoHospitalTemp = solicitacaoCast.anestesiaDoHospital ? '1' : '2'
      }

      if (solicitacaoCast.alergiaLatex !== undefined) {
        solicitacaoCast.alergiaLatexTemp = solicitacaoCast.alergiaLatex ? '1' : '2'
      }

      if (solicitacaoCast.precaucoes !== undefined) {
        solicitacaoCast.precaucaoTemp = _.toUpper(solicitacaoCast.precaucoes) === 'SIM' ? '1' : '2'
      }

      switch (solicitacaoCast.temMedicamentosEspeciais) {
        case undefined:
          solicitacaoCast.medEspeciaisTemp = ''
          break
        case null:
          solicitacaoCast.medEspeciaisTemp = ''
          break
        case true:
          solicitacaoCast.medEspeciaisTemp = '1'
          break
        case false:
          solicitacaoCast.medEspeciaisTemp = '2'
          break
        default:
          solicitacaoCast.medEspeciaisTemp = ''
      }

      switch (solicitacaoCast.temPrevisaoUsoQuimioterapico) {
        case undefined:
          solicitacaoCast.usoQuimioTemp = ''
          break
        case null:
          solicitacaoCast.usoQuimioTemp = ''
          break
        case true:
          solicitacaoCast.usoQuimioTemp = '1'
          break
        case false:
          solicitacaoCast.usoQuimioTemp = '2'
          break
        default:
          solicitacaoCast.usoQuimioTemp = ''
      }

      if (solicitacaoCast.recemNascido !== undefined) {
        solicitacaoCast.recemNascidoTemp = solicitacaoCast.recemNascido ? '1' : '2'
      }

      return solicitacaoCast
    }

    return {}
  }

  @Action
  async getDataAgendamento(solicitacaoId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getDataAgendamentoChat(solicitacaoId)

    this.context.commit('setShowAlteracaoDataAgendamento', true)
    this.context.commit('setAlteracaoDataMensagens', request.data.mensagens)
    if (request.success) {
      return request.data
    }

    return {}
  }

  @Action
  async medicoRespondeOrcamentoDeCirurgiaParticular(params: any) {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.medicoRespondeOrcamentoDeCirurgiaParticular(params)
    return response
  }

  @Action
  async postAlteracaoDataAgendamento(alterarDataAgendamento: AlteracaoDataAgendamento) {
    const { solicitacaoId } = alterarDataAgendamento
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.postAlteracaoDataAgendamento(solicitacaoId, alterarDataAgendamento)
    return request
  }

  @Action
  async cancelarSolicitacao(solicitacaoId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.cancelarSolicitacao(solicitacaoId)
    return request
  }

  @Action
  async autorizacaoParcial(solicitacaoId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.autorizacaoParcial(solicitacaoId)
    return request
  }

  @Action({ commit: 'setEnviarSolicitacao' })
  async loadAssinarEnviar(user: any) {
    const isEnviarSolicitacao = assinarEnviar(user)
    return isEnviarSolicitacao
  }

  @Action({ commit: 'setInstrumentador' })
  async loadInstrumentador(user: any) {
    const result = instrumentador(user)
    return result
  }

  @Action({ commit: 'setAgendamentosMedico' })
  async LoadAgendamentosMedico(query: SolicitacaoQueryString) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAll(query)
    if (request.success) {
      const conveniosCast = await this.forceCast<Array<AgendamentoMedico>>(request.data.solicitacoes)
      this.context.commit('setAgendamentosMedicoTotal', request.data.totalSolicitacoes)
      this.context.commit('setAgendamentosSituacaoFiltros', request.data.situacaoFiltros)
      this.context.commit('setAgendamentosSituacaoDataFiltros', request.data.situacaoDataFiltros)
      return conveniosCast
    }
    return []
  }

  @Action({ commit: 'setMedicos' })
  async LoadAllMedicoByInstrumentadorId(user?: any) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllMedicoByInstrumentadorId()
    // .SolicitacaoCirurgiaApi.getAllMedicoByInstrumentadorId(user.sub)
    if (request.success) {
      const medicosCast = await this
        .forceCast<Array<Medico[]>>(request.data)
      return medicosCast
    }
    return []
  }

  @Action({ commit: 'setHospitais' })
  async LoadHospitais(medicoId: string) {
    const medicoSolicitanteId = medicoId

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getHospitais(medicoSolicitanteId)
    if (request.success) {
      const data = request.data.map((c) => {
        const hospital = c
        hospital.id = _.toUpper(c.id)
        hospital.nome = _.toUpper(c.nome)
        return hospital
      })
      const hospitaisCast = await this.forceCast<Hospital[]>(data)
      return hospitaisCast
    }
    return []
  }

  @Action
  async LoadConvenios() {
    if (this.solicitacao.hospitalId) {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllConvenio(this.solicitacao.hospitalId)

      if (request.success) {
        const conveniosCast = await this.forceCast<Array<Convenio>>(request.data)
        this.context.commit('setConvenios', conveniosCast)
      }
    }
  }

  @Action
  async loadPlanos() {
    if (this.solicitacao.hospitalId && this.solicitacao.convenio) {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi
        .getAllPlanos(this.solicitacao.hospitalId, this.solicitacao.convenio)

      if (request.success) {
        const planosCast = await this.forceCast<Plano>(request.data)
        this.context.commit('setPlanos', planosCast)
      }
    }
  }

  @Action({ commit: 'setShowModalCid' })
  showModalCid(show: boolean) {
    return show
  }

  @Action({ commit: 'setShowModalProcedimentoPrincipal' })
  showModalProcedimentoPrincipal(show: boolean) {
    return show
  }

  @Action({ commit: 'setShowModalProcedimentoAssociado' })
  showModalProcedimentoAssociado(show: boolean) {
    return show
  }

  @Action({ commit: 'setShowModalProcedimentoQuantidade' })
  async showModalProcedimentoQuantidade(show: boolean) {
    return show
  }

  @Action({ commit: 'setShowModalOpme' })
  showModalOpme(show: boolean) {
    return show
  }

  @Action({ commit: 'setShowModalOpmeFornecedor' })
  showModalOpmeFornecedor(show: boolean) {
    return show
  }

  @Action
  async showModalItensAutorizados(solicitacaoId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.get(solicitacaoId)
    if (request.success) {
      const test = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllLaudos(solicitacaoId, TipoDocumentoUpload.AnexoOperadora)

      if (test.success) {
        const { data } = request
        this.context.commit('setItemAutorizado', {
          status: {
            key: (data.canceladoMotivo && data.canceladoMotivo.key) ? data.canceladoMotivo.key : data.statusSituacao,
            display: data.canceladoMotivo && data.canceladoMotivo.display ? data.canceladoMotivo.display : splitUppercase(data.statusSituacao),
          },
          autorizacaoValidade: data.autorizacaoValidade,
          anexos: [...test.data],
          justificativa: data.autorizacaoObservacao,
        })
        this.context.commit('setShowModalItensAutorizados', true)
        this.context.commit('setSolicitacaoId', solicitacaoId)
      }
    }
  }

  @Action
  async showModalItensAutorizadosClinica(solicitacaoId: string) {
    this.context.commit('setShowModalItensAutorizadosClinica', true)
    this.context.commit('setSolicitacaoId', solicitacaoId)
  }

  @Action
  async showModalMotivoCancelamento(solicitacaoId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.get(solicitacaoId)

    if (request.success) {
      this.solicitacao.motivoCancelamentoDescricao = request.data.motivoCancelamentoDescricao
      const test = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllLaudos(solicitacaoId, TipoDocumentoUpload.AnexoOperadora)

      if (test.success) {
        const { data } = request
        this.context.commit('setMotivoCancelamento', {
          status: {
            key: (data.canceladoMotivo && data.canceladoMotivo.key) ? data.canceladoMotivo.key : data.statusSituacao,
            display: data.canceladoMotivo && data.canceladoMotivo.display ? data.canceladoMotivo.display : splitUppercase(data.statusSituacao),
          },
          canceladoMotivo: {
            key: (data.canceladoMotivo && data.canceladoMotivo.key) ? data.canceladoMotivo.key : data.statusSituacao,
            display: data.canceladoMotivo && data.canceladoMotivo.display ? data.canceladoMotivo.display : splitUppercase(data.statusSituacao),
          },
          anexos: [...test.data],
          justificativa: data.autorizacaoObservacao,
        })
        this.context.commit('setShowModalMotivoCancelamento', true)
        this.context.commit('setSolicitacaoId', solicitacaoId)
      }
    }
  }

  @Action({ commit: 'setShowModalEquipamento' })
  showModalEquipamento(show: boolean) {
    return show
  }

  @Action({ commit: 'setShowModalTecnicaRobotica' })
  showModalTecnicaRobotica(show: boolean) {
    return show
  }

  @Action({ commit: 'setShowModalHospitalOpcoes' })
  showModalHospitalOpcoes(show: boolean) {
    return show
  }

  @Action({ commit: 'setShowModalGerenciar' })
  showModalGerenciar(show: boolean) {
    return show
  }

  @Action({ commit: 'setLaudos' })
  async loadLaudos() {
    let documentos: any[] = []
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi
      .getAllLaudos(this.solicitacao.id, TipoDocumentoUpload.Laudo)
    if (request.success) {
      const laudosCast = await this.forceCast<Laudo[]>(request.data)
      laudosCast.map((e: any) => {
        const c = e
        c.tipoDocumento = 'Laudo'
        return c
      })
      documentos = [...documentos, ...laudosCast]
      return documentos
    }

    return []
  }

  @Action
  async getOrcamentoAnexo(solicitacaoId: string) {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getOrcamentosBySolicitacaoId(solicitacaoId)
    if (response.success) {
      this.context.commit('setOrcamentoAnexo', response.data)
    }
    return response
  }

  @Action
  async uploadLaudos(params: any) {
    const solicitacaoId = this.solicitacao.id
    const formData = params.format
    const headers = params.header
    const request = Apis.Agendamento.SolicitacaoCirurgiaApi.upload(formData, TipoDocumentoUpload.Laudo, headers, solicitacaoId)

    if (request.success) {
      const laudosCast = await this.forceCast<Laudo>(request.data)
      this.context.commit('setLaudos', laudosCast)
    }

    return request
  }

  @Action
  async deleteLaudo(params: any) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteLaudoById(params.hospitalId, params.id)
    return request
  }

  @Action
  async deleteReservaHemocomponente(tipo: string) {
    const solicitacaoId = this.solicitacao.id
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteReservaHemocomponente(solicitacaoId, tipo)
    return request
  }

  @Action({ commit: 'setCidsApi' })
  async getCidSearch(searchText: string) {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getCidSearch(this.solicitacao.hospitalId, this.solicitacao.medicoSolicitanteId, searchText)
      return request.success ? [...request.data] as Cid[] : [] as Cid[]
    } catch (error) {
      return [] as Cid[]
    }
  }

  @Action({ commit: 'setCids' })
  async loadAllCidBySolicitacaoId() {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllCidBySolicitacaoId(this.solicitacao.id)

    if (request.success) {
      return this.forceCast<Cid>(request.data)
    }

    return []
  }

  @Action
  async postCid(cid: Cid) {
    if (this.cids && this.cids.length > 0 && this.cids.some((_cid: Cid) => _cid.id === cid.id)) {
      return { success: false, message: 'Este CID já está incluso na lista...' }
    }

    const solicitacaoId = this.solicitacao.id
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.postCid(solicitacaoId, cid)
    return request
  }

  @Action
  async deleteCid(cid: Cid) {
    const cidId = cid.id
    const solicitacaoId = this.solicitacao.id

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteCid(solicitacaoId, cidId)
    return request
  }

  @Action({ commit: 'setOPMEs' })
  async LoadOpmes() {
    const solicitacaoId = this.solicitacao.id
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getOpmes(solicitacaoId)

    if (request.success) {
      return this.forceCast<ProtocoloOPME[]>(request.data)
    }

    return []
  }

  @Action({ commit: 'setProcedimentosApi' })
  async getProcedimentoSearch(searchText: string) {
    const { medicoSolicitanteId } = this.solicitacao
    const { hospitalId } = this.solicitacao
    const { convenioId } = this.solicitacao.paciente

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getProcedimentoSearch(medicoSolicitanteId, hospitalId, convenioId, searchText)
    return request
  }

  @Action({ commit: 'setEquipamentos' })
  async loadEquipamentos(): Promise<ISolicitacaoStoreEquipamento> {
    const solicitacaoId = this.solicitacao.id

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getEquipamentos(solicitacaoId)
    if (request.success) {
      return this.forceCast<ISolicitacaoStoreEquipamento[]>(request.data)
    }

    return {} as ISolicitacaoStoreEquipamento
  }

  @Action({ commit: 'setProtocoloOPMEsApi', rawError: true })
  async getOpmeSearch(searchText: string) {
    const { medicoSolicitanteId, convenio, hospitalId, procedimento, procedimentosAssociados } = this.solicitacao

    const procedimentos: string[] = []
    procedimentos.push(procedimento!.id)
    procedimentosAssociados!.map(p => procedimentos.push(p.id))

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getOpmeSearch(medicoSolicitanteId, searchText, procedimentos, convenio, hospitalId)

    if (request) {
      return request.data
    }

    return []
  }

  @Action({ commit: 'setEquipamentosApi' })
  async getAllGrupoEquipamentoParaOMedico(searchText: string) {
    const { hospitalId } = this.solicitacao
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllGrupoEquipamentoParaOMedico(hospitalId, searchText)
    return request.success
      ? this.forceCast<Equipamento[]>(request.data.map(elem => elem.grupoEquipamento).filter(elem => !elem.exibeApenasParaOBackoffice))
      : []
  }

  @Action
  async sendDataAgendamentoMensagem(mensagem: AlteracaoDataMensagem) {
    this.context.commit('setAlteracaoDataMensagem', mensagem)
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.postDataAgendamentoMensagem(this.solicitacao.id, mensagem)

    return request
  }

  @Action
  async salvarNovoFornecedor() {
    const fornecedor = {
      ...this.novoFornecedor,
      medicoId: this.solicitacao.medicoSolicitanteId,
      hospitalId: this.solicitacao.hospitalId,
      nomeFabricante: [null, undefined, ''].includes(this.novoFornecedor.nomeFabricante) ? '' : this.novoFornecedor.nomeFabricante,
      contato: formatPhoneMask(this.novoFornecedor.contato),
    }

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.salvarNovoFornecedor(fornecedor)

    if (request.success) {
      const { hospitalId, id } = this.solicitacao
      const convenioId = this.solicitacao.convenio || 'e8496173-7c9d-43b2-9f01-4d490d69042b'
      const medicoId = this.solicitacao.medicoSolicitanteId
      const req = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllFornecedor(hospitalId, convenioId, medicoId, id)

      if (req.success) {
        const fornecedores = req.data
        this.context.commit('setFornecedores', fornecedores)
        return { success: true }
      }
    }
    return { success: false }
  }

  @Mutation
  setNovoFornecedor(value: NovoFornecedor) {
    const fornecedor = {
      ...value,
      medicoId: this.solicitacao.medicoSolicitanteId,
      hospitalId: this.solicitacao.hospitalId,
      contato: formatPhoneMask(value.contato),
    }
    this.novoFornecedor = fornecedor
  }

  @Mutation
  clearNovoFornecedor() {
    this.novoFornecedor = { ...this.novoFornecedorDefault }
  }

  @Mutation
  setDataNascimentoTemp(dn: string) {
    this.solicitacao.dataNascimentoTemp = dn
  }

  @Mutation
  setAlteracaoDataMensagem(mensagem: AlteracaoDataMensagem) {
    this.alteracaoDataAgendamentoMensagens.push(mensagem)
  }

  @Mutation
  setAlteracaoDataMensagens(mensagem: AlteracaoDataMensagem[]) {
    this.alteracaoDataAgendamentoMensagens = mensagem
  }

  @Mutation
  fillHemocomponentes(hemocomponentes: Hemocomponente[]) {
    hemocomponentes.map((c: Hemocomponente) => {
      switch (_.toUpper(c.tipo)) {
        case 'CONCENTRADOHEMACIAS':
          this.reservaHemocomponente.concentradoHemacias.quantidade = c.quantidade
          this.reservaHemocomponente.concentradoHemacias.value = true
          break
        case 'CONCENTRADOPLAQUETAS':
          this.reservaHemocomponente.concentradoPlaquetas.quantidade = c.quantidade
          this.reservaHemocomponente.concentradoPlaquetas.value = true
          break
        case 'CRIOPRECIPITADO':
          this.reservaHemocomponente.crioprecipitado.quantidade = c.quantidade
          this.reservaHemocomponente.crioprecipitado.value = true
          break
        case 'PLASMAFRESCOCONGELADO':
          this.reservaHemocomponente.plasmaFrescoCongelado.quantidade = c.quantidade
          this.reservaHemocomponente.plasmaFrescoCongelado.value = true
          break
        case 'TIPAGEMSANGUINEAABORHPAI':
          this.reservaHemocomponente.tipagemSanguineaABORHPAI.quantidade = c.quantidade
          this.reservaHemocomponente.tipagemSanguineaABORHPAI.value = true
          break
        case 'SEMRESERVA':
          this.reservaHemocomponente.semReserva.quantidade = c.quantidade
          this.reservaHemocomponente.semReserva.value = true
          break
        default:
          break
      }

      return c
    })
  }

  @Action({ commit: 'fillHemocomponentes' })
  async getReservaHemocomponente() {
    const solicitacaoId = this.solicitacao.id
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllReservaHemocomponentes(solicitacaoId)

    if (request.success) {
      const hemocomponenteCast = this.forceCast<Hemocomponente[]>(request.data)
      return hemocomponenteCast
    }
    return []
  }

  @Action
  async postReservaHemocomponente(hemocomponente: Hemocomponente) {
    const solicitacaoId = this.solicitacao.id
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.postReservaHemocomponente(solicitacaoId, hemocomponente)
    return request
  }

  @Action({ commit: 'setEquipamento' })
  async postEquipamento(equipamento: Equipamento) {
    const solicitacaoId = this.solicitacao.id
    const grupoEquipamentoId = equipamento.id

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.postEquipamento(solicitacaoId, { grupoEquipamentoId })
    if (request.success) {
      return equipamento
    }

    return {}
  }

  @Action
  async postOpme(opme: OPME) {
    const solicitacaoId = this.solicitacao.id
    const opmeApi = { ...opme, medicoId: this.solicitacao.medicoSolicitanteId }

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.postOpme(solicitacaoId, opmeApi)
    if (request.success) {
      const opmeResult = opmeApi
      const opmeResponse = await this.forceCast<OpmePostResponse>(request.data)
      opmeResult.id = opmeResponse.id
      return opmeResult
    }

    return {}
  }

  @Action
  async getHospitalTermsOfUse(hospitalId: string) {
    const APIRequest = await Apis.Agendamento.SolicitacaoCirurgiaApi.getHospitalTermsOfUse(hospitalId)
    return APIRequest.data
  }

  @Action
  async acceptHospitalTermsOfUse(hospitalId: string) {
    const requestBody: any = {
      hospitalId,
      tipos: [
        'TermoDeUso',
      ],
    }

    const APIRequest = await Apis.Agendamento.SolicitacaoCirurgiaApi.acceptHospitalTermsOfUse({ hospitalId, requestBody })
    return APIRequest
  }

  @Action
  async deleteOpme(opme: OPME) {
    const solicitacaoId = this.solicitacao.id
    const opmeId = opme.id || ''
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteOpme(solicitacaoId, opmeId)
    return request
  }

  @Action({ commit: 'removeEquipamento' })
  async deleteEquipamento(equipamento: Equipamento) {
    const solicitacaoId = this.solicitacao.id
    const equipamentoId = equipamento.id
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteGrupoEquipamento(solicitacaoId, equipamentoId)
    return request
  }

  @Action({ commit: 'setProcedimentoPrincipal' })
  async deleteProcedimentoPrincipal() {
    return null
  }

  @Action({ commit: 'removeAllProcedimentoAssociado' })
  async clearAllProcedimentosAssociados() {
    // Limpa todos os procedimentos associados
  }

  @Action({ commit: 'setFornecedores' })
  async loadFornecedores() {
    const { hospitalId, id } = this.solicitacao
    const convenioId = this.solicitacao.convenio || 'e8496173-7c9d-43b2-9f01-4d490d69042b'
    const medicoId = this.solicitacao.medicoSolicitanteId

    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getAllFornecedor(hospitalId, convenioId, medicoId, id)
    if (request.success) {
      const fornecedores = this.forceCast<Fornecedor[]>(request.data)
      return fornecedores
    }
    return []
  }

  @Action({ commit: 'setFornecedores' })
  async loadFornecedorProtocoloOPMESelected() {
    const temp: Fornecedor[] = []

    this.protocoloOPMESelected.opmes.map((c) => {
      if (c.fornecedores) {
        c.fornecedores.map((f) => {
          if (!temp.some(p => p.fornecedorId === f.fornecedorId)) {
            temp.push(f)
          }
          return f
        })
      }
      return c
    })

    return temp
  }

  @Action({ commit: 'setTemplateHospital' })
  async loadHospitalTemplate(hospitalId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getTemplateHospital(hospitalId)
    if (request.success) {
      return request.data.templateName
    }
    return ''
  }


  @Action({ commit: 'setHospital' })
  async getHospitalById(hospitalId: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getHospitalById(hospitalId)

    if (request.success) {
      return request.data
    }

    return {}
  }

  @Action({ commit: 'setCarater' })
  loadCarater(value: string) {
    return value
  }

  @Action({ commit: 'setMedicoId' })
  setMedicoSolicitanteId(value: string) {
    return value
  }

  @Action
  async atualizaLocalAtendimento(localAtendimentoId: string) {
    const params: any = {
      medicoId: this.medicoSolicitante.id,
      localAtendimentoId,
    }

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.updateLocalAtendimento(params)
    if (request.success) {
      return true
    }

    return false
  }

  @Action
  async getConfiguracoes() {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getConfiguracoes()
    if (response.success) {
      return response.data.medicos
    }
    return false
  }

  @Action
  async adicionaMedicoLocalAtendimento(params: any) {
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.adicionaMedicoLocalAtendimento(params)
    if (response.success) {
      return true
    }
    return false
  }

  @Action
  async getHospitaisByUserCurrent() {
    try {
      const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getHospitaisByUserCurrent()
      this.context.commit('setAgendamentosHospitalFiltros', response.success ? response.data : [])
      this.context.commit('setCurrentUserHospitals', response.success ? response.data : [])
    } catch (error) {
      this.context.commit('setAgendamentosHospitalFiltros', [])
      this.context.commit('setCurrentUserHospitals', [])
    }
  }

  @Mutation
  setAnySolicitacaoField(field: string, value: any) {
    this.solicitacao[field] = value
  }

  @Mutation
  setShowForm(value: boolean) {
    this.showForm = value
  }

  @Mutation
  setCarater(value: string) {
    this.solicitacao.caraterTemp = value
  }

  @Mutation
  setSolicitacaoId(value: string) {
    this.solicitacao.id = value
  }

  @Mutation
  setInstrumentador(value: boolean) {
    this.isInstrumentador = value
  }

  @Mutation
  setEnviarSolicitacao(value: boolean) {
    this.isEnviarSolicitacao = value
  }

  @Mutation
  setShowModalCid(value: boolean) {
    this.modalSolicitacaoCirurgia.showCid = value
  }

  @Mutation
  setShowAlteracaoDataAgendamento(value: boolean) {
    this.modalSolicitacaoCirurgia.showAlteracaoDataSolicitada = value
  }

  @Mutation
  setShowAlteracaoDataAgendamentoClinica(value: boolean) {
    this.modalSolicitacaoCirurgia.showAlteracaoDataSolicitadaClinica = value
  }

  @Mutation
  setShowModalPendenciaProtocolo(value: boolean) {
    this.modalSolicitacaoCirurgia.showModalPendenciaProtocolo = value
  }

  @Mutation
  setAgendamentosMedico(values: AgendamentoMedico[]) {
    this.agendamentosMedico = values
  }

  @Mutation
  setAgendamentosMedicoTotal(value: number) {
    this.agendamentosMedicoTotal = value
  }

  @Mutation
  setAgendamentosSituacaoFiltros(value: Situacao[]) {
    // Mudança do display de Autorizada Parcial para Autorizada Parcial
    const situacoes = value.map((situacao): Situacao => {
      const sit = situacao
      if (sit.key === 'AutorizadaParcial') sit.display = 'Autorizada Parcial'
      return sit
    }) || []
    this.agendamentosSituacaoFiltros = situacoes
  }

  @Mutation
  setAgendamentosSituacaoDataFiltros(value: Situacao[]) {
    this.agendamentosSituacaoDataFiltros = value || []
  }

  @Mutation
  setAgendamentosHospitalFiltros(value: Hospital[]) {
    this.agendamentosHospitalFiltros = value || []
  }

  @Mutation
  setCurrentUserHospitals(data: Hospital[]) {
    this.currentUserHospitals = data || []
  }

  @Mutation
  setMedicos(values: Medico[]) {
    this.medicos = values
  }

  @Mutation
  setHospitais(values: Hospital[]) {
    this.hospitais = values
  }

  @Mutation
  setItemAutorizado(value: ItemAutorizado) {
    this.itemAutorizado = value
  }

  @Mutation
  setMotivoCancelamento(value: MotivoCancelamento) {
    this.motivoCancelamento = value
  }

  @Mutation
  setShowModalProcedimentoPrincipal(value: boolean) {
    this.modalSolicitacaoCirurgia.showProcedimentoPrincipal = value
  }

  @Mutation
  setShowModalProcedimentoAssociado(value: boolean) {
    this.modalSolicitacaoCirurgia.showProcedimentoAssociado = value
  }

  @Mutation
  setShowModalProcedimentoQuantidade(value: boolean) {
    this.modalSolicitacaoCirurgia.showQuantidade = value
  }

  @Mutation
  setShowModalProcedimentoAssociadoQuantidade(value: boolean) {
    this.modalSolicitacaoCirurgia.showAssociadoQuantidade = value
  }

  @Mutation
  setShowModalOpme(value: boolean) {
    this.modalSolicitacaoCirurgia.showOpme = value
  }

  @Mutation
  setShowModalItensAutorizados(value: boolean) {
    this.modalSolicitacaoCirurgia.showItensAutorizados = value
  }

  @Mutation
  setShowModalItensAutorizadosClinica(value: boolean) {
    this.modalSolicitacaoCirurgia.showItensAutorizadosClinica = value
  }

  @Mutation
  setShowModalMotivoCancelamento(value: boolean) {
    this.modalSolicitacaoCirurgia.showMotivoCancelamento = value
  }

  @Mutation
  setShowModalOpmeFornecedor(value: boolean) {
    this.modalSolicitacaoCirurgia.showOpmeFornecedor = value
  }

  @Mutation
  setShowModalProtocoloFornecedor(value: boolean) {
    this.modalSolicitacaoCirurgia.showProtocoloFornecedor = value
  }

  @Mutation
  setShowModalEquipamento(value: boolean) {
    this.modalSolicitacaoCirurgia.showEquipamento = value
  }

  @Mutation
  setShowModalTecnicaRobotica(value: boolean) {
    this.modalSolicitacaoCirurgia.showTecnicaRobotica = value
  }

  @Mutation
  setShowModalHospitalOpcoes(value: boolean) {
    this.modalSolicitacaoCirurgia.showHospitalOpcoes = value
  }

  @Mutation
  setShowModalGerenciar(value: boolean) {
    this.modalSolicitacaoCirurgia.showGerenciar = value
  }

  @Mutation
  setShowModalSair(value: boolean) {
    this.modalSolicitacaoCirurgia.showSair = value
  }

  @Mutation
  setSolicitacao(value: Solicitacao) {
    this.solicitacao = value
  }

  @Mutation
  setConvenios(value: Convenio[]): void {
    this.convenios = value
  }

  @Mutation
  setConvenio(convenioId: string): void {
    this.solicitacao.convenio = convenioId
  }

  @Mutation
  setCodigoPrestador(value: string): void {
    this.solicitacao.codigoPrestador = value
  }

  @Mutation
  setPlanos(value: Plano[]): void {
    this.planos = value
  }

  @Mutation
  setLaudos(value: Laudo[]): void {
    this.laudos = value
  }

  @Mutation
  setOrcamentoAnexo(value: Laudo[]): void {
    this.orcamentoAnexo = value
  }

  @Mutation
  setHospitalId(value: string): void {
    this.solicitacao.hospitalId = _.toUpper(value)
  }

  @Mutation
  setHospital(value: Hospital): void {
    this.hospital = value
  }

  @Mutation
  setStatusSituacao(value: string): void {
    this.solicitacao.statusSituacao = value
  }

  @Mutation
  setTemplateHospital(value: string): void {
    this.templateHospital.hospital = value
  }

  @Mutation
  setIdade(value: number | null): void {
    this.solicitacao.idade = value
  }

  @Mutation
  setErrorMessage(value: ErrorMessage) {
    this.errorMessage = value
  }

  @Mutation
  clearSolicitacao() {
    this.showForm = true
    this.solicitacao = { ...this.solicitacaoDefault }
    this.solicitacao.tempoDeDoenca = null
    this.errorMessage = { ...this.errorMessageDefault }
    this.convenios = []
    this.planos = []
    this.protocoloOPMEs = []
    this.equipamentos = []
    this.equipamentosSugeridos = []
    this.laudos = []
    this.cids = []
    this.reservaHemocomponente = {
      concentradoHemacias: {
        quantidade: null,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: null,
        value: false,
      },
      crioprecipitado: {
        quantidade: null,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: null,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: null,
        value: false,
      },
      semReserva: {
        quantidade: null,
        value: false,
      },
    }
    this.solicitacao.procedimentosAssociados = []
  }

  @Mutation
  clearOpcaoData(element: any) {
    this.solicitacao[element] = null
  }

  @Mutation
  clearErrorMessage() {
    this.errorMessage = { ...this.errorMessageDefault }
  }

  @Mutation
  clearMedicamentosEspeciais() {
    this.solicitacao.medicamentosEspeciais = ''
  }

  @Mutation
  clearAgendamentosMedico() {
    this.agendamentosMedico = []
  }

  @Mutation
  clearDataPrevisto1() {
    this.solicitacao.opcaoDataPrevisto1Temp = ''
  }

  @Mutation
  clearDataPrevisto2() {
    this.solicitacao.opcaoDataPrevisto2Temp = ''
  }

  @Mutation
  clearDataPrevisto3() {
    this.solicitacao.opcaoDataPrevisto3Temp = ''
  }

  @Mutation
  clearEspecificarPrecaucoes() {
    this.solicitacao.especificarPrecaucoes = ''
  }

  @Mutation
  clearPrevisaoUsoQuimioterapico() {
    this.solicitacao.previsaoUsoQuimioterapico = ''
  }

  @Mutation
  clearProcedimentoQuantidade() {
    this.procedimentoQuantidade = { ...this.procedimentoDefault }
  }

  @Mutation
  clearOpmeFornecedorSelected() {
    this.protocoloOPMESelected = { ...this.protocoloOPMEDefault }
  }

  @Mutation
  clearProtocoloOPMEsApi(protocoloOPMe: ProtocoloOPME) {
    if (protocoloOPMe.protocolo) {
      this.protocoloOPMEsApi = this.protocoloOPMEsApi
        .filter(c => c.protocoloId !== protocoloOPMe.protocoloId)
    } else {
      this.protocoloOPMEsApi = this.protocoloOPMEsApi
        .filter(c => c.opmes[0].id !== protocoloOPMe.opmes[0].id)
    }
  }

  @Mutation
  clearProtocoloOPMEs(protocoloOPMe: ProtocoloOPME) {
    this.protocoloOPMEs = this.protocoloOPMEs
      .filter(c => c.position !== protocoloOPMe.position)
  }

  @Mutation
  clearCodigoPrestador() {
    this.solicitacao.codigoPrestador = ''
  }

  @Mutation
  clearItemAutorizado() {
    this.itemAutorizado = { ...this.itemAutorizadoDefault }
  }

  @Mutation
  clearMotivoCancelamento() {
    this.motivoCancelamento = { ...this.motivoCancelamentoDefault }
  }

  @Mutation
  clearAlteracaoDataAgendamento() {
    this.alteracaoDataAgendamentoMensagens = { ...this.alteracaoDataAgendamentoMensagensDefault }
  }

  @Mutation
  setMedicoId(medicoId: string) {
    this.solicitacao.medicoSolicitanteId = medicoId
  }

  @Mutation
  setPaciente(paciente: any) {
    this.solicitacao.paciente = paciente
  }

  @Mutation
  setProcedimentoApi(procedimento: Procedimento) {
    this.procedimentosApi.push(procedimento)
  }

  @Mutation
  setProcedimentoAssociado(procedimento: Procedimento) {
    this.solicitacao.procedimentosAssociados!.push(procedimento)
    EventBus.$emit('changeProcedimento', 'procedimentoAssociado')
  }

  @Mutation
  setProcedimentoAssociadoCoberturaVigente(procedimento: Procedimento) {
    const procedimentoIndex = this.solicitacao.procedimentosAssociados!.findIndex((proc: Procedimento) => proc.id === procedimento.id) || 0
    this.solicitacao.procedimentosAssociados![procedimentoIndex] = procedimento
    EventBus.$emit('changeProcedimento')
  }

  @Mutation
  setProcedimentoAssociados(procedimentos: Procedimento[]) {
    this.solicitacao.procedimentosAssociados = procedimentos || []
    EventBus.$emit('changeProcedimento', 'procedimentoAssociado')
  }

  @Mutation
  setProcedimentoQuantidade(procedimento: Procedimento) {
    this.procedimentoQuantidade = procedimento
  }

  @Mutation
  setProtocoloFornecedorSelected(protocoloOPME: ProtocoloOPME) {
    this.protocoloOPMESelected = protocoloOPME
  }

  @Mutation
  setCid(cid: Cid) {
    this.cids.push(cid)
  }

  @Mutation
  setCidApi(cid: Cid) {
    this.cidsApi.push(cid)
  }

  @Mutation
  setCidsApi(cids: Cid[]) {
    this.cidsApi = [...cids]
  }

  @Mutation
  setCids(cids: Cid[]) {
    this.cids = [...cids]
  }

  @Mutation
  setProcedimentosApi(procedimentosRequest: any) {
    if (procedimentosRequest.success) {
      const procedimentos = [...procedimentosRequest.data]
      const { procedimentosAssociados } = this.solicitacao
      const procedimento = this.solicitacao.procedimento || this.procedimentoDefault
      const procedimentosAssociadosIds: string[] = []

      if (procedimentosAssociados && procedimentosAssociados.length > 0) {
        procedimentosAssociados.map((e: any) => procedimentosAssociadosIds.push(e.id))
        procedimentosAssociadosIds.forEach((e: string) => {
          const indexAssociados = procedimentos.findIndex(c => c.id === e)
          if (![-1, null, undefined].includes(indexAssociados)) procedimentos.splice(indexAssociados, 1)
        })
      }

      if (!['', null, undefined].includes(procedimento!.id)) {
        const indexPrincipal = procedimentos.findIndex(c => c.id === procedimento!.id)
        if (![-1, null, undefined].includes(indexPrincipal)) procedimentos.splice(indexPrincipal, 1)
      }

      if (this.templateFormulario && this.templateFormulario.formulario
          && this.templateFormulario.formulario.lateralidade
          && this.templateFormulario.formulario.lateralidade.exigeLateralidadeEmTodosOsProcedimentos) {
        this.procedimentosApi = procedimentos.map((proced: any) => {
          const proc = proced
          proc.temLateralidade = true
          return proc
        })
      } else {
        this.procedimentosApi = procedimentos
      }
    } else {
      this.procedimentosApi = []
    }
  }

  @Mutation
  setProtocoloOPMEsApi(value: ProtocoloOPME[]) {
    for (let i = 0; i < value.length; i++) {
      value[i].position = i
    }

    this.protocoloOPMEsApi = value
  }

  @Mutation
  setProtocoloOPMEApi(value: ProtocoloOPME) {
    this.protocoloOPMEsApi.push(value)
  }

  @Mutation
  setProtocoloOPME(value: ProtocoloOPME) {
    this.protocoloOPMEs.push(value)
  }

  @Mutation
  setEnableModalProtocoloFornecedor(value: boolean) {
    this.enableModalProtocoloFornecedor = value
  }

  @Mutation
  setProtocoloOPMEs(opmes: ProtocoloOPME) {
    const temp: ProtocoloOPME = opmes
    temp.position = this.protocoloOPMEs.length + 1
    this.protocoloOPMEs.push(temp)
  }

  @Mutation
  setOPMEs(protocolosOPMEs: ProtocoloOPME[]) {
    for (let i = 0; i < protocolosOPMEs.length; i++) {
      protocolosOPMEs[i].position = i
    }

    protocolosOPMEs.map(p => p.opmes.map((o) => {
      if (o.fornecedores) {
        o.fornecedores.sort((n1, n2) => {
          if (n1.opcao > n2.opcao) {
            return 1
          }
          if (n1.opcao < n2.opcao) {
            return -1
          }
          return 0
        })
      }
      return o
    }))

    this.protocoloOPMEs = []
    this.protocoloOPMEs = protocolosOPMEs
  }

  @Mutation
  setProtocoloOPMEsValidate() {
    const opmes = this.protocoloOPMESelected.opmes.map((c) => {
      if (!c.quantidade || c.quantidade < 0) {
        c.mensagem = 'Por favor informar quantidade.'
      } else {
        c.mensagem = ''
      }

      if (!c.termo) {
        c.termoMensagem = 'Por favor informe o nome do material'
      } else {
        c.termoMensagem = ''
      }

      return c
    })

    this.protocoloOPMESelected.opmes = opmes
  }

  @Mutation
  setEquipamentosApi(equipamentos: Equipamento[]) {
    const equipamentosIds: string[] = this.equipamentos.map(e => e.id) || []
    this.equipamentosApi = (equipamentos as any).filter((e: any) => e.id && !equipamentosIds.includes(e.id))
  }

  @Mutation
  setEquipamentoApi(equipamento: Equipamento) {
    this.equipamentosApi.push(equipamento)
  }

  @Mutation
  setEquipamento(equipamento: Equipamento) {
    this.equipamentos.push(equipamento)
  }

  @Mutation
  setEquipamentos(equipamentos: ISolicitacaoStoreEquipamento) {
    this.equipamentos = equipamentos.equipamentosDaSolicitacao
    this.equipamentosSugeridos = equipamentos.equipamentosSugeridos
  }

  @Mutation
  setProcedimentoPrincipal(procedimento: Procedimento | null) {
    if (procedimento && procedimento.id) {
      this.solicitacao.procedimento = procedimento
      EventBus.$emit('changeProcedimento', 'procedimentoPrincipal')
    } else {
      this.solicitacao.procedimento = { ...this.procedimentoDefault }
      EventBus.$emit('changeProcedimento', 'procedimentoPrincipal')
    }
  }

  @Mutation
  setProcedimentoPrincipalCoberturaVigente(procedimento: Procedimento) {
    if (procedimento) {
      this.solicitacao.procedimento = procedimento
      EventBus.$emit('changeProcedimento')
    }
  }

  @Mutation
  setFornecedores(fornecedores: Fornecedor[]) {
    this.fornecedores = fornecedores
    this.fornecedores.map((c) => {
      const f = c
      f.descricao = f.nome && f.fabricante ? `${f.nome} / ${f.fabricante}` : f.nome
      return f
    })
  }

  @Mutation
  setFornecedorItemDisabled(fornecedores: Fornecedor[]) {
    this.fornecedores.map((c) => {
      const t = c
      t.disabled = fornecedores.some(p => p.fornecedorId === c.fornecedorId)
      return t
    })
  }

  @Mutation
  setAlteracaoDataAgendamento(alteracaoDataAgendamento: AlteracaoDataAgendamento) {
    this.alteracaoDataAgendamento = alteracaoDataAgendamento
  }

  @Mutation
  async removeCidApi(value: Cid) {
    const removeArray: any[] = []

    for (let i = 0; i < this.cidsApi.length; i++) {
      if (this.cidsApi[i].id === value.id) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.cidsApi.splice(removeArray[i], 1)
    }
  }

  @Mutation
  removeCid(value: Cid) {
    const removeArray: any[] = []

    for (let i = 0; i < this.cids.length; i++) {
      if (this.cids[i].id === value.id) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.cids.splice(removeArray[i], 1)
    }
  }

  @Mutation
  removeProcedimentoAssociado(value: Procedimento) {
    const removeArray: any[] = []

    const { procedimentosAssociados } = this.solicitacao

    for (let i = 0; i < procedimentosAssociados!.length; i++) {
      if (procedimentosAssociados![i].id === value.id) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      procedimentosAssociados!.splice(removeArray[i], 1)
    }

    EventBus.$emit('changeProcedimento', 'procedimentoAssociado')
  }

  @Mutation
  removeAllProcedimentoAssociado() {
    const { procedimentosAssociados } = this.solicitacao
    procedimentosAssociados!.splice(0, procedimentosAssociados!.length)
    EventBus.$emit('changeProcedimento', 'procedimentoAssociado')
  }

  @Mutation
  removeProcedimentoApi(value: Procedimento) {
    const index = this.procedimentosApi.findIndex(c => c.id === value.id)
    if (index > -1) {
      this.procedimentosApi.splice(index, 1)
    }
  }

  @Mutation
  removeEquipamento(value: Equipamento) {
    const removeArray: any[] = []

    for (let i = 0; i < this.equipamentos.length; i++) {
      if (this.equipamentos[i].id === value.id) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.equipamentos.splice(removeArray[i], 1)
    }
  }

  @Mutation
  removeEquipamentoApi(value: Equipamento) {
    const removeArray: any[] = []

    for (let i = 0; i < this.equipamentosApi.length; i++) {
      if (this.equipamentosApi[i].id === value.id) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.equipamentosApi.splice(removeArray[i], 1)
    }
  }

  @Mutation
  removeOpmeApi(value: OPME) {
    const removeArray: any[] = []
  }

  @Mutation
  removeOpme(value: OPME) {
    const removeArray: any[] = []
  }

  @Mutation
  setSnackbar(value: Snackbar) {
    this.snackbar = value
  }

  @Mutation
  setLocaisAtendimento(value: LocalAtendimento[]) {
    this.locaisAtendimento = value
  }

  @Mutation
  setLocalAtendimentoId(value: string | null) {
    this.localAtendimentoId = value
  }

  @Mutation
  setLocalAtendimento(value: LocalAtendimento) {
    this.localAtendimento = value
  }

  @Mutation
  clearLocaisAtendimento() {
    this.locaisAtendimento = [...this.locaisAtendimentoDefault]
  }

  @Mutation
  clearLocalAtendimento() {
    this.localAtendimento = { ...this.localAtendimentoDefault }
  }

  @Mutation
  clearLocalAtendimentoId() {
    this.localAtendimentoId = ''
  }

  public tecnicasDisponiveis: Array<{ id: string, descricao: string }> = []

  @Mutation
  setTecnicasDisponiveis(value: Array<{ id: string, descricao: string }>) {
    this.tecnicasDisponiveis = value
  }

  @Mutation
  clearTecnicasDisponiveis() {
    this.tecnicasDisponiveis = []
  }
}

export interface ISolicitacaoStoreEquipamento {
  equipamentosDaSolicitacao: Equipamento[];
  equipamentosSugeridos: Equipamento[];
}
